(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_city_smartb_f2_f2_dsl_cqrs.js', './kotlin_city_smartb_f2_f2_dsl_function.js', './kotlin_city_smartb_ssm_ssm_chaincode_dsl.js', './kotlin_city_smartb_s2_s2_automate_dsl.js', './kotlin_org_axessimpact_measure_unit_domain.js', './kotlin_org_axessimpact_protocol_type_domain.js', './kotlin_org_axessimpact_protocol_type_api_domain.js', './kotlin_city_smartb_fs_file_domain.js', './kotlin_org_axessimpact_fs_domain.js', './kotlin_org_axessimpact_project_domain.js', './kotlin_org_axessimpact_protocol_domain.js', './kotlin_org_axessimpact_protocol_api_domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_city_smartb_f2_f2_dsl_cqrs.js'), require('./kotlin_city_smartb_f2_f2_dsl_function.js'), require('./kotlin_city_smartb_ssm_ssm_chaincode_dsl.js'), require('./kotlin_city_smartb_s2_s2_automate_dsl.js'), require('./kotlin_org_axessimpact_measure_unit_domain.js'), require('./kotlin_org_axessimpact_protocol_type_domain.js'), require('./kotlin_org_axessimpact_protocol_type_api_domain.js'), require('./kotlin_city_smartb_fs_file_domain.js'), require('./kotlin_org_axessimpact_fs_domain.js'), require('./kotlin_org_axessimpact_project_domain.js'), require('./kotlin_org_axessimpact_protocol_domain.js'), require('./kotlin_org_axessimpact_protocol_api_domain.js'));
  else {
    if (typeof kotlin_city_smartb_f2_f2_dsl_cqrs === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_city_smartb_f2_f2_dsl_cqrs' was not found. Please, check whether 'kotlin_city_smartb_f2_f2_dsl_cqrs' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_city_smartb_f2_f2_dsl_function === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_city_smartb_f2_f2_dsl_function' was not found. Please, check whether 'kotlin_city_smartb_f2_f2_dsl_function' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_city_smartb_ssm_ssm_chaincode_dsl === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_city_smartb_ssm_ssm_chaincode_dsl' was not found. Please, check whether 'kotlin_city_smartb_ssm_ssm_chaincode_dsl' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_city_smartb_s2_s2_automate_dsl === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_city_smartb_s2_s2_automate_dsl' was not found. Please, check whether 'kotlin_city_smartb_s2_s2_automate_dsl' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_org_axessimpact_measure_unit_domain === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_org_axessimpact_measure_unit_domain' was not found. Please, check whether 'kotlin_org_axessimpact_measure_unit_domain' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_org_axessimpact_protocol_type_domain === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_org_axessimpact_protocol_type_domain' was not found. Please, check whether 'kotlin_org_axessimpact_protocol_type_domain' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_org_axessimpact_protocol_type_api_domain === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_org_axessimpact_protocol_type_api_domain' was not found. Please, check whether 'kotlin_org_axessimpact_protocol_type_api_domain' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_city_smartb_fs_file_domain === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_city_smartb_fs_file_domain' was not found. Please, check whether 'kotlin_city_smartb_fs_file_domain' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_org_axessimpact_fs_domain === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_org_axessimpact_fs_domain' was not found. Please, check whether 'kotlin_org_axessimpact_fs_domain' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_org_axessimpact_project_domain === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_org_axessimpact_project_domain' was not found. Please, check whether 'kotlin_org_axessimpact_project_domain' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_org_axessimpact_protocol_domain === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_org_axessimpact_protocol_domain' was not found. Please, check whether 'kotlin_org_axessimpact_protocol_domain' is loaded prior to 'axess-project-api-domain'.");
    }
    if (typeof kotlin_org_axessimpact_protocol_api_domain === 'undefined') {
      throw new Error("Error loading module 'axess-project-api-domain'. Its dependency 'kotlin_org_axessimpact_protocol_api_domain' was not found. Please, check whether 'kotlin_org_axessimpact_protocol_api_domain' is loaded prior to 'axess-project-api-domain'.");
    }
    root['axess-project-api-domain'] = factory(typeof this['axess-project-api-domain'] === 'undefined' ? {} : this['axess-project-api-domain'], kotlin_city_smartb_f2_f2_dsl_cqrs, kotlin_city_smartb_f2_f2_dsl_function, kotlin_city_smartb_ssm_ssm_chaincode_dsl, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_org_axessimpact_measure_unit_domain, kotlin_org_axessimpact_protocol_type_domain, kotlin_org_axessimpact_protocol_type_api_domain, kotlin_city_smartb_fs_file_domain, kotlin_org_axessimpact_fs_domain, kotlin_org_axessimpact_project_domain, kotlin_org_axessimpact_protocol_domain, kotlin_org_axessimpact_protocol_api_domain);
  }
}(this, function (_, kotlin_city_smartb_f2_f2_dsl_cqrs, kotlin_city_smartb_f2_f2_dsl_function, kotlin_city_smartb_ssm_ssm_chaincode_dsl, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_org_axessimpact_measure_unit_domain, kotlin_org_axessimpact_protocol_type_domain, kotlin_org_axessimpact_protocol_type_api_domain, kotlin_city_smartb_fs_file_domain, kotlin_org_axessimpact_fs_domain, kotlin_org_axessimpact_project_domain, kotlin_org_axessimpact_protocol_domain, kotlin_org_axessimpact_protocol_api_domain) {
  'use strict';
  //region block: pre-declaration
  //endregion
  function ProjectCreateResultDTO() {
  }
  ProjectCreateResultDTO.$metadata$ = {
    simpleName: 'ProjectCreateResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectUpdateResultDTO() {
  }
  ProjectUpdateResultDTO.$metadata$ = {
    simpleName: 'ProjectUpdateResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectGetAllPublishedQueryDTO() {
  }
  ProjectGetAllPublishedQueryDTO.$metadata$ = {
    simpleName: 'ProjectGetAllPublishedQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectGetAllPublishedQueryResultDTO() {
  }
  ProjectGetAllPublishedQueryResultDTO.$metadata$ = {
    simpleName: 'ProjectGetAllPublishedQueryResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectGetAllQueryDTO() {
  }
  ProjectGetAllQueryDTO.$metadata$ = {
    simpleName: 'ProjectGetAllQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectGetAllQueryResultDTO() {
  }
  ProjectGetAllQueryResultDTO.$metadata$ = {
    simpleName: 'ProjectGetAllQueryResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectGetQueryDTO() {
  }
  ProjectGetQueryDTO.$metadata$ = {
    simpleName: 'ProjectGetQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectGetQueryResultDTO() {
  }
  ProjectGetQueryResultDTO.$metadata$ = {
    simpleName: 'ProjectGetQueryResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectGetRefsQueryDTO() {
  }
  ProjectGetRefsQueryDTO.$metadata$ = {
    simpleName: 'ProjectGetRefsQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectGetRefsQueryResultDTO() {
  }
  ProjectGetRefsQueryResultDTO.$metadata$ = {
    simpleName: 'ProjectGetRefsQueryResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectListSimilarQueryDTO() {
  }
  ProjectListSimilarQueryDTO.$metadata$ = {
    simpleName: 'ProjectListSimilarQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectListSimilarResultDTO() {
  }
  ProjectListSimilarResultDTO.$metadata$ = {
    simpleName: 'ProjectListSimilarResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectDTO() {
  }
  ProjectDTO.$metadata$ = {
    simpleName: 'ProjectDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectRefDTO() {
  }
  ProjectRefDTO.$metadata$ = {
    simpleName: 'ProjectRefDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectStatusDTO() {
  }
  ProjectStatusDTO.$metadata$ = {
    simpleName: 'ProjectStatusDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProjectStatusValues() {
    ProjectStatusValues_instance = this;
  }
  ProjectStatusValues.prototype.created = function () {
    return 'Created';
  };
  ProjectStatusValues.prototype.published = function () {
    return 'Published';
  };
  ProjectStatusValues.prototype.closed = function () {
    return 'Closed';
  };
  ProjectStatusValues.$metadata$ = {
    simpleName: 'ProjectStatusValues',
    kind: 'object',
    interfaces: []
  };
  var ProjectStatusValues_instance;
  function ProjectStatusValues_getInstance() {
    if (ProjectStatusValues_instance == null)
      new ProjectStatusValues();
    return ProjectStatusValues_instance;
  }
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$features = $org$axess$f2$project$api$domain.features || ($org$axess$f2$project$api$domain.features = {});
    var $org$axess$f2$project$api$domain$features$command = $org$axess$f2$project$api$domain$features.command || ($org$axess$f2$project$api$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$features = $org$axess$f2$project$api$domain.features || ($org$axess$f2$project$api$domain.features = {});
    var $org$axess$f2$project$api$domain$features$command = $org$axess$f2$project$api$domain$features.command || ($org$axess$f2$project$api$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$features = $org$axess$f2$project$api$domain.features || ($org$axess$f2$project$api$domain.features = {});
    var $org$axess$f2$project$api$domain$features$query = $org$axess$f2$project$api$domain$features.query || ($org$axess$f2$project$api$domain$features.query = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$features = $org$axess$f2$project$api$domain.features || ($org$axess$f2$project$api$domain.features = {});
    var $org$axess$f2$project$api$domain$features$query = $org$axess$f2$project$api$domain$features.query || ($org$axess$f2$project$api$domain$features.query = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$features = $org$axess$f2$project$api$domain.features || ($org$axess$f2$project$api$domain.features = {});
    var $org$axess$f2$project$api$domain$features$query = $org$axess$f2$project$api$domain$features.query || ($org$axess$f2$project$api$domain$features.query = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$features = $org$axess$f2$project$api$domain.features || ($org$axess$f2$project$api$domain.features = {});
    var $org$axess$f2$project$api$domain$features$query = $org$axess$f2$project$api$domain$features.query || ($org$axess$f2$project$api$domain$features.query = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$features = $org$axess$f2$project$api$domain.features || ($org$axess$f2$project$api$domain.features = {});
    var $org$axess$f2$project$api$domain$features$query = $org$axess$f2$project$api$domain$features.query || ($org$axess$f2$project$api$domain$features.query = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$model = $org$axess$f2$project$api$domain.model || ($org$axess$f2$project$api$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$model = $org$axess$f2$project$api$domain.model || ($org$axess$f2$project$api$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$project = $org$axess$f2.project || ($org$axess$f2.project = {});
    var $org$axess$f2$project$api = $org$axess$f2$project.api || ($org$axess$f2$project.api = {});
    var $org$axess$f2$project$api$domain = $org$axess$f2$project$api.domain || ($org$axess$f2$project$api.domain = {});
    var $org$axess$f2$project$api$domain$model = $org$axess$f2$project$api$domain.model || ($org$axess$f2$project$api$domain.model = {});
    Object.defineProperty($org$axess$f2$project$api$domain$model, 'ProjectStatusValues', {
      configurable: true,
      get: ProjectStatusValues_getInstance
    });
  }
  $jsExportAll$(_);
  kotlin_city_smartb_f2_f2_dsl_cqrs.$jsExportAll$(_);
  kotlin_city_smartb_f2_f2_dsl_function.$jsExportAll$(_);
  kotlin_city_smartb_ssm_ssm_chaincode_dsl.$jsExportAll$(_);
  kotlin_city_smartb_s2_s2_automate_dsl.$jsExportAll$(_);
  kotlin_org_axessimpact_measure_unit_domain.$jsExportAll$(_);
  kotlin_org_axessimpact_protocol_type_domain.$jsExportAll$(_);
  kotlin_org_axessimpact_protocol_type_api_domain.$jsExportAll$(_);
  kotlin_city_smartb_fs_file_domain.$jsExportAll$(_);
  kotlin_org_axessimpact_fs_domain.$jsExportAll$(_);
  kotlin_org_axessimpact_project_domain.$jsExportAll$(_);
  kotlin_org_axessimpact_protocol_domain.$jsExportAll$(_);
  kotlin_org_axessimpact_protocol_api_domain.$jsExportAll$(_);
  //endregion
  return _;
}));

//# sourceMappingURL=axess-project-api-domain.js.map